/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { InputAdornment, Snackbar, SnackbarContent, TextField } from '@mui/material';
import { withStyles } from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import * as React from 'react';
import { FileNameforInstrumentConstantsEndpoint } from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';

interface Props {
    handleFileNameSearch: Function,
    classes?: any,
    isLoading: any,
    LoadConstants: Function
    fileName: any
    UpdateFileName: Function
    Updatesearchstatus: Function
    StopLoading: Function
    ClearAll: Function
}
const styles = () => ({
    input: {
        backgroundColor: '#fff',
        height: 48,
        width: 312
    },
    root: {
        justifyContent: 'center'
    }
})

class FileNameSearch extends React.Component<Props> {
    state = {
        open: false,
        checked: undefined,
        setChecked: undefined,
        selectedindex: 0,
        validationError: ''
    };
    handleChange = (event: any) => {
        this.props.UpdateFileName(event.target.value);
    };
    handlekeyPress = (event: any) => {
        this.setState({ selectedindex: 0 });
        if (event.key === 'Enter') {
            try {
                this.props.Updatesearchstatus(true);
                this.props.LoadConstants(event.target.value);
                this.props.ClearAll();
                const token: string = loadFromLocalStorage('AuthToken');
                const encodedToken = 'Bearer ' + token;
                const headerDict: any = {
                    'Authorization': encodedToken,
                    'Content-Type': 'application/json'
                };
                const endpoint = FileNameforInstrumentConstantsEndpoint;
                fetch(endpoint, {
                    headers: new Headers(headerDict),
                    body: JSON.stringify({
                        'FileName': event.target.value
                    }),
                    method: 'POST'
                })
                    .then(async (response: any) => {
                        this.props.Updatesearchstatus(false);
                        switch (response.status) {
                            case 200:
                                const data = await response.json();
                                this.props.handleFileNameSearch(data);
                                break;
                            case 400:
                                this.setState({ validationError: 'Please enter a minimum of 6 digits' });
                                this.props.StopLoading();
                                break;
                            case 204:
                                this.setState({ validationError: 'Invalid Parameters' });
                                this.props.StopLoading();
                                break;
                            case 500:
                                this.setState({ validationError: 'Server Error' });
                                this.props.StopLoading();
                                break;
                            default:
                                this.setState({ validationError: 'Constant not found' });
                                this.props.StopLoading();
                        }
                    });
            }
            catch (e) { console.log(e); }
        }
    };

    handleClose = (value: any) => {
        this.props.StopLoading();
        this.setState({ selectedValue: value, open: false });
    };
    handleSnackBarClose = (event: any, reason: any) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ validationError: '' });
    };
    handleCheckboxChange = (index: any) => {
        this.setState({ selectedindex: index });
    };

    render() {
        const { classes } = this.props;
        const { fileName } = this.props;
        return (
            <div >
                <TextField
                    name="fileName"
                    onChange={this.handleChange}
                    onKeyPress={this.handlekeyPress}
                    value={fileName}
                    variant="outlined"
                    InputProps={{
                        className: classes.input, startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    InputLabelProps={{ shrink: false }}
                    label={fileName === '' ? 'IC File Name' : ''}
                    className="serialNumberinput"
                />

                <Snackbar
                    anchorOrigin={{
                        horizontal: 'left',
                        vertical: 'bottom'
                    }}
                    open={this.state.validationError !== ''}
                    autoHideDuration={5000}
                    onClose={this.handleSnackBarClose}
                >
                    <SnackbarContent
                        className="search-input-snackbar"
                        message={this.state.validationError}
                    />
                </Snackbar>
            </div>
        );
    }
}

export default ((withStyles(styles))(FileNameSearch));
